import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";

const NAV_LINKS = [
  { label: "Products", href: "#what-we-do" },
  { label: "Values", href: "#why-anantora" },
  { label: "Contact", href: "#contact" },
];

const scrollTo = (href) => {
  const el = document.querySelector(href);
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 80);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.nav
      data-testid="site-navbar"
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1], delay: 0.1 }}
      style={{
        position: "fixed",
        top: 0, left: 0, right: 0,
        zIndex: 100,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "20px clamp(24px, 6vw, 96px)",
        background: scrolled ? "rgba(3,3,3,0.92)" : "transparent",
        backdropFilter: scrolled ? "blur(24px)" : "none",
        borderBottom: `1px solid ${scrolled ? "#1A1A1A" : "transparent"}`,
        transition: "background 0.5s ease, backdrop-filter 0.5s ease, border-color 0.5s ease",
      }}
    >
      <a
        data-testid="navbar-logo"
        href="/"
        style={{
          fontFamily: "'Cabinet Grotesk', sans-serif",
          fontWeight: 800,
          fontSize: "15px",
          letterSpacing: "0.2em",
          color: "#F4F4F0",
          textDecoration: "none",
        }}
      >
        ANANTORA
      </a>

      <div style={{ display: "flex", gap: "clamp(16px, 3vw, 40px)", alignItems: "center" }}>
        {NAV_LINKS.map((link) => (
          <NavLink key={link.href} link={link} />
        ))}
      </div>
    </motion.nav>
  );
};

const NavLink = ({ link }) => {
  const isContact = link.label === "Contact";
  const [hovered, setHovered] = useState(false);

  return (
    <button
      data-testid={`nav-link-${link.label.toLowerCase()}`}
      onClick={() => scrollTo(link.href)}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        fontFamily: "'JetBrains Mono', monospace",
        fontSize: "11px",
        letterSpacing: "0.14em",
        color: hovered ? "#F4F4F0" : isContact ? "#CCCCCC" : "#666666",
        background: "transparent",
        border: isContact ? `1px solid ${hovered ? "#FF3B00" : "#2A2A2A"}` : "none",
        padding: isContact ? "8px 20px" : "0",
        cursor: "pointer",
        transition: "color 0.3s ease, border-color 0.3s ease",
      }}
    >
      {link.label.toUpperCase()}
    </button>
  );
};

export default Navbar;
